import ArticleShell from "@/components/site/ArticleShell";

const BodyEs = () => (
  <div className="article-body">
    <p>Si has llegado hasta aquí, probablemente estás atravesando algo grande. Un diagnóstico reciente, un tratamiento que está dejando huella, o el momento extraño del "después" en el que el cuerpo ya no es el de antes pero la vida sigue su curso.</p>
    <p>Quiero contarte cómo es realmente una sesión de <strong>yoga oncológico online</strong>, sin tecnicismos y sin promesas vacías. Lo escribo desde donde lo conozco: viví mi propio proceso de cáncer mientras me formaba como profesora de yoga, y de esa experiencia nació Método TAO.</p>
    <h2>Qué es exactamente el yoga oncológico (y qué no es)</h2>
    <p>El yoga oncológico no es yoga "normal" un poco rebajado. Es <strong>otra cosa</strong>.</p>
    <p>Cuando alguien atraviesa un proceso oncológico, su cuerpo no necesita más exigencia, ni "dar caña", ni superar ningún reto físico. Necesita exactamente lo contrario: un espacio donde poder <em>soltar</em>. Donde la respiración vuelva a ser amplia, donde el sistema nervioso encuentre calma, y donde no tengas que disimular cómo estás.</p>
    <p>El yoga oncológico es un trabajo cuerpo-mente que combina:</p>
    <ul>
      <li><strong>Posturas adaptadas</strong> a tu energía actual (puedes hacer la sesión entera sentada si lo necesitas)</li>
      <li><strong>Respiración terapéutica</strong> para regular el sistema nervioso</li>
      <li><strong>Mindfulness y presencia</strong> sin tecnicismos espirituales</li>
      <li><strong>Regulación emocional</strong>: hay espacio para el miedo, la rabia, la tristeza</li>
      <li><strong>Descanso profundo guiado</strong></li>
    </ul>
    <h2>Por qué la modalidad online a veces funciona mejor que la presencial</h2>
    <p><strong>Lo online tiene ventajas reales que en presencial no tienes:</strong></p>
    <ul>
      <li><strong>Estás en tu propia casa.</strong> El cuerpo se relaja mucho más rápido en un entorno conocido y seguro.</li>
      <li><strong>No necesitas energía extra para desplazarte.</strong> Durante un tratamiento oncológico o con fatiga crónica, es decisivo.</li>
      <li><strong>Puedes hacer la sesión desde la cama.</strong> Si un día estás cansadísima tras la quimio, hacemos toda la sesión sentada o recostada.</li>
      <li><strong>Sin contagios.</strong> En tratamiento oncológico, esto importa mucho.</li>
      <li><strong>Funciona desde cualquier país.</strong> Trabajo con mujeres en España, México, Argentina, Colombia y otros países hispanohablantes.</li>
    </ul>
    <h2>Cómo es una primera sesión online de Método TAO, paso a paso</h2>
    <h3>Antes de la sesión</h3>
    <p>Reservas. Te mando un email confirmando, con un enlace de videollamada y un pequeño cuestionario para que me cuentes lo que quieras: diagnóstico, fase del proceso, contraindicaciones (cirugía reciente, port-a-cath, linfedema, neuropatía…). Todo confidencial.</p>
    <p><strong>Necesitamos el permiso de tu oncólogo o equipo médico antes de empezar las sesiones.</strong> Es un paso imprescindible: el yoga oncológico es complementario, no alternativo.</p>
    <p>Una manta y dos cojines te bastan. Si tienes esterilla, mejor.</p>
    <h3>Durante la sesión</h3>
    <p>La primera sesión dura entre 60 y 75 minutos. Empezamos hablando 10-15 minutos: cómo te sientes hoy, qué has venido a buscar. <strong>No hay guion cerrado</strong>.</p>
    <ol>
      <li><strong>Respiración y aterrizaje</strong> — para activar el sistema nervioso parasimpático.</li>
      <li><strong>Movimiento amable y posturas restaurativas</strong> — apoyadas con cojines, mantas, sin exigencia.</li>
      <li><strong>Cierre y descanso profundo guiado</strong> — los últimos 10-15 minutos.</li>
    </ol>
    <h2>Para quién está pensado</h2>
    <ul>
      <li>Personas con un <strong>diagnóstico oncológico reciente</strong></li>
      <li>Pacientes en <strong>tratamiento activo</strong> (quimio, radio, cirugía, hormonoterapia)</li>
      <li>Personas en la fase de <strong>secuelas y recuperación</strong> post-tratamiento</li>
      <li>Mujeres con <strong>fibromialgia, dolor crónico o fatiga</strong></li>
      <li>Personas con <strong>ansiedad o insomnio</strong></li>
      <li>Quien tiene <strong>movilidad reducida</strong></li>
    </ul>
    <h2>Lo que NO es yoga oncológico (mitos frecuentes)</h2>
    <ul>
      <li><strong>No es alternativo a tu tratamiento médico.</strong> Es complementario.</li>
      <li><strong>No es solo "relajación".</strong> Es un trabajo profesional con base en neurociencia.</li>
      <li><strong>No es espiritual ni religioso.</strong></li>
      <li><strong>No es para "ponerte en forma".</strong></li>
    </ul>
    <h2>Qué cambia cuando incorporas esto a tu proceso</h2>
    <ul>
      <li>Bajar los niveles de <strong>ansiedad y angustia</strong></li>
      <li>Mejorar la <strong>calidad del sueño</strong></li>
      <li>Reducir la <strong>sensación de dolor</strong></li>
      <li>Recuperar la <strong>movilidad amable</strong> tras cirugía</li>
      <li>Disminuir la <strong>fatiga</strong></li>
      <li>Reconectarte con un cuerpo que probablemente sientes ajeno</li>
      <li><strong>Devolverte autonomía y sensación de sostén</strong></li>
    </ul>
    <blockquote>El diagnóstico te quita autonomía y el acompañamiento te la devuelve.</blockquote>
    <h2>Cómo empezar (sin prisa, sin compromiso)</h2>
    <p>Antes de reservar una sesión completa, ofrezco una <strong>llamada gratuita de 15 minutos</strong> para que me cuentes en qué momento estás. Sin guion. Sin venderte nada. Solo escucha.</p>
  </div>
);

const BodyCa = () => (
  <div className="article-body">
    <p>Si has arribat fins aquí, probablement estàs travessant alguna cosa gran. Un diagnòstic recent, un tractament que està deixant petjada, o el moment estrany del "després" en què el cos ja no és el d'abans però la vida segueix el seu curs.</p>
    <p>Et vull explicar com és realment una sessió de <strong>ioga oncològic online</strong>, sense tecnicismes i sense promeses buides. Ho escric des d'on ho conec: vaig viure el meu propi procés de càncer mentre em formava com a professora de ioga, i d'aquesta experiència va néixer el Mètode TAO.</p>
    <h2>Què és exactament el ioga oncològic (i què no és)</h2>
    <p>El ioga oncològic no és ioga "normal" una mica rebaixat. És <strong>una altra cosa</strong>.</p>
    <p>Quan algú travessa un procés oncològic, el seu cos no necessita més exigència, ni "donar canya", ni superar cap repte físic. Necessita exactament el contrari: un espai on poder <em>deixar anar</em>. On la respiració torni a ser àmplia, on el sistema nerviós trobi calma, i on no hagis de dissimular com estàs.</p>
    <p>El ioga oncològic és un treball cos-ment que combina:</p>
    <ul>
      <li><strong>Postures adaptades</strong> a la teva energia actual (pots fer la sessió sencera asseguda si ho necessites)</li>
      <li><strong>Respiració terapèutica</strong> per regular el sistema nerviós</li>
      <li><strong>Mindfulness i presència</strong> sense tecnicismes espirituals</li>
      <li><strong>Regulació emocional</strong>: hi ha espai per a la por, la ràbia, la tristesa</li>
      <li><strong>Descans profund guiat</strong></li>
    </ul>
    <h2>Per què la modalitat online de vegades funciona millor que la presencial</h2>
    <p><strong>L'online té avantatges reals que en presencial no tens:</strong></p>
    <ul>
      <li><strong>Ets a casa teva.</strong> El cos es relaxa molt més de pressa en un entorn conegut i segur.</li>
      <li><strong>No necessites energia extra per desplaçar-te.</strong> Durant un tractament oncològic o amb fatiga crònica, és decisiu.</li>
      <li><strong>Pots fer la sessió des del llit.</strong> Si un dia estàs cansadíssima després de la quimio, fem tota la sessió asseguda o estirada.</li>
      <li><strong>Sense contagis.</strong> En tractament oncològic, això importa molt.</li>
      <li><strong>Funciona des de qualsevol país.</strong> Treballo amb dones a Espanya, Mèxic, Argentina, Colòmbia i altres països hispanoparlants.</li>
    </ul>
    <h2>Com és una primera sessió online del Mètode TAO, pas a pas</h2>
    <h3>Abans de la sessió</h3>
    <p>Reserves. T'envio un email confirmant, amb un enllaç de videotrucada i un petit qüestionari perquè m'expliquis el que vulguis: diagnòstic, fase del procés, contraindicacions (cirurgia recent, port-a-cath, limfedema, neuropatia…). Tot confidencial.</p>
    <p><strong>Necessitem el permís del teu oncòleg o equip mèdic abans de començar les sessions.</strong> És un pas imprescindible: el ioga oncològic és complementari, no alternatiu.</p>
    <p>Una manta i dos coixins són suficients. Si tens estora, millor.</p>
    <h3>Durant la sessió</h3>
    <p>La primera sessió dura entre 60 i 75 minuts. Comencem parlant 10-15 minuts: com et sents avui, què has vingut a buscar. <strong>No hi ha guió tancat</strong>.</p>
    <ol>
      <li><strong>Respiració i aterratge</strong> — per activar el sistema nerviós parasimpàtic.</li>
      <li><strong>Moviment amable i postures restauratives</strong> — recolzades amb coixins, mantes, sense exigència.</li>
      <li><strong>Tancament i descans profund guiat</strong> — els últims 10-15 minuts.</li>
    </ol>
    <h2>Per a qui està pensat</h2>
    <ul>
      <li>Persones amb un <strong>diagnòstic oncològic recent</strong></li>
      <li>Pacients en <strong>tractament actiu</strong> (quimio, radio, cirurgia, hormonoteràpia)</li>
      <li>Persones en fase de <strong>seqüeles i recuperació</strong> post-tractament</li>
      <li>Dones amb <strong>fibromiàlgia, dolor crònic o fatiga</strong></li>
      <li>Persones amb <strong>ansietat o insomni</strong></li>
      <li>Qui té <strong>mobilitat reduïda</strong></li>
    </ul>
    <h2>El que NO és ioga oncològic (mites freqüents)</h2>
    <ul>
      <li><strong>No és alternatiu al teu tractament mèdic.</strong> És complementari.</li>
      <li><strong>No és només "relaxació".</strong> És un treball professional amb base en neurociència.</li>
      <li><strong>No és espiritual ni religiós.</strong></li>
      <li><strong>No és per "posar-te en forma".</strong></li>
    </ul>
    <h2>Què canvia quan incorpores això al teu procés</h2>
    <ul>
      <li>Baixar els nivells d'<strong>ansietat i angoixa</strong></li>
      <li>Millorar la <strong>qualitat del son</strong></li>
      <li>Reduir la <strong>sensació de dolor</strong></li>
      <li>Recuperar la <strong>mobilitat amable</strong> després de cirurgia</li>
      <li>Disminuir la <strong>fatiga</strong></li>
      <li>Reconnectar-te amb un cos que probablement sents aliè</li>
      <li><strong>Tornar-te autonomia i sensació de suport</strong></li>
    </ul>
    <blockquote>El diagnòstic et treu autonomia i l'acompanyament te la torna.</blockquote>
    <h2>Com començar (sense pressa, sense compromís)</h2>
    <p>Abans de reservar una sessió completa, ofereixo una <strong>trucada gratuïta de 15 minuts</strong> perquè m'expliquis en quin moment estàs. Sense guió. Sense vendre't res. Només escolta.</p>
  </div>
);

const ArticleYogaOncologico = () => (
  <ArticleShell
    bodyEs={<BodyEs />}
    bodyCa={<BodyCa />}
    leadMagnet={{
      guide: "yoga-oncologico",
      source: "blog/yoga-oncologico-online-como-funciona",
      title: { es: "Cómo prepararte para tu primera sesión de yoga oncológico", ca: "Com preparar-te per a la teva primera sessió de ioga oncològic" },
      subtitle: { es: "La mini-guía que comparto con cada paciente nueva. Todo lo que necesitas saber antes, durante y después de tu primera sesión, sin tecnicismos.", ca: "La mini-guia que comparteixo amb cada pacient nova. Tot el que necessites saber abans, durant i després de la teva primera sessió, sense tecnicismes." },
      bullets: {
        es: ["Qué pedirle a tu oncólogo y por qué importa", "Qué necesitas tener a mano (no es lo que crees)", "Cómo preparar tu espacio para una sesión online", "Qué reacciones son normales después de la sesión"],
        ca: ["Què demanar al teu oncòleg i per què importa", "Què necessites tenir a mà (no és el que creus)", "Com preparar el teu espai per a una sessió online", "Quines reaccions són normals després de la sessió"],
      },
    }}
  />
);

export default ArticleYogaOncologico;
